export default function blank(value = '') {
  if (Array.isArray(value) && !value.length) {
    return true;
  }

  if (['', undefined, null].includes(value)) {
    return true;
  }

  if (String(value).trim() === '') {
    return true;
  }


  return false;
}

blank.message = function message(value, options = {}) {
  return options.message || 'não pode ficar em branco';
};
